<template>
  <div class="exam">
    <div class="nuv">
      <!-- <a href="/tjkStudy/examlist" class="active">考试中心</a>&gt; -->
      <span>{{ data.examName }}</span>
    </div>
    <div class="left">
      <div class="exam-con">
        <!-- <h2>{{ data.examName }}</h2> -->
        <div class="content">
          <template v-for="(l, key) in paperQuestion">
            <div class="type">
              <div class="title">
                <p>{{ getNum(key) }}、{{ l.questionGroupTittle }}（共{{ l.questionDetailList.length }}题）共{{ l.totalScore }}分</p>
              </div>
              <div class="list" v-for="(q, index) in l.questionDetailList">
                <template v-if="q.question">
                  <!--填空题 题干-->
                  <template v-if="q.questionType == 'BlankFilling'">
                    <p :id="savelist[key][index].num">{{ savelist[key][index].num }}、
                      <template v-for="(s, k) in q.question.questionContent.questionStem">
                        <span v-html="replaceNToBr(s)"></span>
                        <el-input v-model="savelist[key][index].tjkAnswerString[k]" v-show="k != q.question.questionContent.questionStem.length - 1" placeholder="请输入答案"></el-input>
                      </template>
                    </p>
                  </template>
                  <!--选择填空题 题干-->
                  <template v-else-if="q.questionType == 'BlankChoice'">
                    <p :id="savelist[key][index].num">{{ savelist[key][index].num }}、
                      <template v-for="(s, k) in q.question.questionContent.questionStem">
                        <span v-html="replaceNToBr(s)"></span>
                        <input type="text" class="answer-input" size="1" maxlength="1" placeholder="请输入答案" v-show="k != q.question.questionContent.questionStem.length - 1" v-model="savelist[key][index].tjkAnswerString[k]" />
                      </template>
                    </p>
                  </template>
                  <!--其余题型 题干-->
                  <template v-else>
                    <p :id="savelist[key][index].num">{{ savelist[key][index].num }}、<span v-html="replaceNToBr(q.question.questionContent.questionStemString)"></span></p>
                  </template>
                  <!--图片-->
                  <p v-if="q.question.questionContent.imageUrlList">
                    <template v-for="i in q.question.questionContent.imageUrlList">
                      <img class="s-img" :src="i" v-if="i != ''" @click="clickImg($event)" />
                    </template>
                  </p>
                  <!--单选题 选项-->
                  <template v-if="q.questionType == 'SingleChoice'">
                    <div class="answer">
                      <p v-for="(value, k) in q.question.questionContent.choices"><el-radio v-model="savelist[key][index].tjkAnswerString" :label="k" >{{ k }}、{{ value }}</el-radio></p>
                    </div>
                  </template>
                  <!--多选题 选项-->
                  <template v-else-if="q.questionType == 'MultipleChoice'">
                    <div class="answer">
                      <el-checkbox-group v-model="savelist[key][index].tjkAnswerString">
                        <p v-for="(value, k) in q.question.questionContent.choices">
                          <el-checkbox :label="k">{{ k }}、{{ value }}</el-checkbox>
                        </p>
                      </el-checkbox-group>
                    </div>
                  </template>
                  <!--判断题 选项-->
                  <template v-else-if="q.questionType == 'TrueOrFalse'">
                    <div class="answer">
                      <el-radio-group v-model="savelist[key][index].tjkAnswerString">
                        <p><el-radio :label="true">正确</el-radio></p>
                        <p><el-radio :label="false">错误</el-radio></p>
                      </el-radio-group>
                    </div>
                  </template>
                  <!--选择填空题 选项-->
                  <template v-else-if="q.questionType == 'BlankChoice'">
                    <div class="answer">
                      <p v-for="(value, k) in q.question.questionContent.choices">
                        <span>{{ k }}、{{ value }}</span>
                      </p>
                    </div>
                  </template>
                  <!--简答题 答案-->
                  <template v-else-if="q.questionType == 'ShortAnswer'">
                    <div class="answer">
                      <p>答案：<textarea class="answer-input shortanswer" v-model="savelist[key][index].tjkAnswerString"></textarea></p>
                    </div>
                  </template>
                </template>
              </div> 
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="count">
        <h2>统计</h2>
        <div class="useTime">
          <p>距自动交卷时间</p>
          <span class="blue">{{ time }}</span>
        </div>
        <div class="useTime">
          <p class="txt">满分{{ data.totalScore }}分，{{ data.passScore }}分及格</p>
        </div>
        <ul>
          <li v-for="s in list" :class="{active3 : getClass(s.tjkAnswerString) }"><a :href="'#'+s.num">{{ s.num }}</a></li>
        </ul>
        <div class="btn">
          <div class="hold" @click="saveExam">保存</div>
          <div class="submit" @click="submitExam">提交试卷</div>
        </div>
      </div>
    </div>
    <zoom-img v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></zoom-img>
  </div>
</template>

<script>
import zoomImg from '../components/zoomImg.vue'
export default {
  data() {
    return {
      'success': true,
      'message': '',
      'id': this.$route.params.id, //examConfigId
      'trainId': this.$route.params.trainId,
      'data': {},
      'paperQuestion': [],
      'examRecordId': '',
      'endTime': '',
      'time': '',
      'showImg': false,
      'imgSrc': '',
      'num': [],
      'savelist': [],
      'list': []//保存时的结果集转换的一维数组，用作答题卡
    }
  },
  components: {
    'zoom-img': zoomImg
  },
  created() {
    // this.firstStep();
  },
  mounted: function() {
    this.queryTrainJoinedTjk();
    // this.getExam()
  },
  watch: {
    paperQuestion: function() {
      for(var i=0;i<this.paperQuestion.length;i++) {
        var xti = []
        var numlength = parseInt(this.num.length)
        for(var j=0;j<this.paperQuestion[i].questionDetailList.length;j++) {
          this.num.push(j)

          if(this.paperQuestion[i].questionDetailList[j].questionType == 'SingleChoice' || this.paperQuestion[i].questionDetailList[j].questionType == 'TrueOrFalse' || this.paperQuestion[i].questionDetailList[j].questionType == 'ShortAnswer') {
            var temp = {
              'num': numlength+j+1,
              'examRecordId': this.paperQuestion[i].questionDetailList[j].examRecordId,
              'sequence': this.paperQuestion[i].questionDetailList[j].sequence,
              'tjkAnswerString': this.paperQuestion[i].questionDetailList[j].tjkAnswer != null ? this.paperQuestion[i].questionDetailList[j].tjkAnswer : ''
            }
          }else {
            var temp = {
              'num': numlength+j+1,
              'examRecordId': this.paperQuestion[i].examRecordId,
              'sequence': this.paperQuestion[i].questionDetailList[j].sequence,
              'tjkAnswerString': this.paperQuestion[i].questionDetailList[j].tjkAnswer != null ? this.paperQuestion[i].questionDetailList[j].tjkAnswer : []
            }
          }
          xti.push(temp)
        }
        this.savelist.push(xti)
      }
      this.list = [].concat.apply([], this.savelist)
    }
  },
  methods: {
    firstStep(){
      let data = {
        examConfigId: this.$route.params.id
      }
      this.$http.post(API_ROOT.system + '/tjkExam/startExam', data)
    },
    async searchExamOnce(){
      let data = {
        pageNum:1,
        pageSize:10,
        examConfigId: this.$route.params.id
      }
      const response = await this.$http.post(API_ROOT.system + '/examRecord/searchExamOnce', data)
      if(!response.data.success){
        return;
      }
      if(response.data.success && response.data.data === true){
        alert('您已经提交了考试')
        window.location.href = '/tjkStudy/examDetailTemp/'+this.$route.params.id
        return;
      }else{
        this.getExam();
      }
      
      // console.log('是否已经参加考试', response);
    },
    async queryTrainJoinedTjk(){
      let data = {
        pageNum:1,
        pageSize:10,
        simpleQuery:'Yes',
        transTokenToTjkId:'Yes',
        trainId: this.$route.params.trainId
      }
      const response = await this.$http.post(API_ROOT.college + '/taojinCollege/queryTrainJoinedTjk', data)
      if(!response.data.success){
        this.$message.error(response.data.msg)
        return;
      }
      let list = response.data.data.list
      if(list && list.length === 0){
        this.$message.error('你尚未报名考试或培训未开始，无法查看考试内容')
        return;
      }
      this.searchExamOnce();
    },
    replaceNToBr:function(str){
      var reg = new RegExp("\n", "g");
      return str.replace(reg, "<br/>");
    },
    getExam() {
      var data = {
        'examConfigId': this.id
      }
      this.$http.post(API_ROOT.system + '/tjkExam/startExam', data).then(response => {
        var result = response.data
        this.success = result.success
        this.message = result.msg
        if (result.success) {
          this.data = result.data
          this.paperQuestion = result.data.paperQuestion
          this.examRecordId = result.data.examRecordId
          if(this.endTime == '') this.endTime = result.data.examRemainingTime
          this.countdown(this.endTime)
        }else {
          alert(result.msg)
          window.location.href = '/tjkStudy/examlist'
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    countdown(endTime) {
      var self = this
      var timer = setInterval(function() {
        endTime--
        if(endTime >= 0) {
          var sec = parseInt(endTime)
          var min = 0
          var hour = 0  
          if(sec > 60) {
            min = parseInt(sec/60)
            sec = parseInt(sec%60)
            if(min > 60) {
              hour = parseInt(min/60)
              min = parseInt(min%60)
            }
          }
          hour = hour < 10 ? "0" + hour : hour
          min = min < 10 ? "0" + min : min
          sec = sec < 10 ? "0" + sec : sec
          if(hour > 0 ) {
            self.time = `${hour}:${min}:${sec}`
          }else {
            self.time =`${min}:${sec}`
          }
          if(endTime == 300) {
            self.open()
          }
        }else {
          clearInterval(timer)
          self.time = '时间到'
          self.submitExamNoconfirm()
        }
      },1000);
    },
    //考试时间提示框
    open() {
      const h = this.$createElement
      this.$notify({
        title: '',
        message: h('i', { style: 'color: red'}, '离自动交卷还有5分钟，请注意答题时间'),
        duration: 5000
      })
    },
    //提交考试前保存——自动提交
    submitExamNoconfirm() {
      var arry = JSON.parse(JSON.stringify(this.list))

      for(var i=0;i<arry.length;i++) {
        if(typeof arry[i].tjkAnswerString != 'string') {
          for(var j=0;j<arry[i].tjkAnswerString.length;j++) {
            var reg= /^[A-Za-z]+$/
            if(arry[i].tjkAnswerString[j] == null) arry[i].tjkAnswerString[j] = ''
            if(reg.test(arry[i].tjkAnswerString[j])) arry[i].tjkAnswerString[j] = arry[i].tjkAnswerString[j].toUpperCase()
          }
          arry[i].tjkAnswerString = JSON.stringify(arry[i].tjkAnswerString)
        }
      }

      var data = {
        'tjkAnswerDetailList': arry
      }
      this.$http.post(API_ROOT.system + '/tjkExam/submitTjkAnswer', data).then(response => {
        var result = response.data
        this.success = result.success
        this.message = result.msg
        if (result.success) {
          this.submitExamFun()
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    async insertOrUpdateEvaluate(){
      let data = {
        examId: this.$route.params.id,
        score: null
      }
      const response = await this.$http.post(API_ROOT.college + '/taojinCollege/insertOrUpdateEvaluate', data)
      if(!response.data.success){
        this.$message.error(response.data.msg)
        return;
      }
      console.log('传递给后台的', response);
    },
    //提交考试前保存——手动提交
    submitExam() {
      this.insertOrUpdateEvaluate();
      var arry = JSON.parse(JSON.stringify(this.list))

      for(var i=0;i<arry.length;i++) {
        if(typeof arry[i].tjkAnswerString != 'string') {
          for(var j=0;j<arry[i].tjkAnswerString.length;j++) {
            var reg= /^[A-Za-z]+$/
            if(arry[i].tjkAnswerString[j] == null) arry[i].tjkAnswerString[j] = ''
            if(reg.test(arry[i].tjkAnswerString[j])) arry[i].tjkAnswerString[j] = arry[i].tjkAnswerString[j].toUpperCase()
          }
          arry[i].tjkAnswerString = JSON.stringify(arry[i].tjkAnswerString)
        }
      }

      var data = {
        'tjkAnswerDetailList': arry
      }
      if(confirm("您确定要提交考试吗？")) {
        this.$http.post(API_ROOT.system + '/tjkExam/submitTjkAnswer', data).then(response => {
          var result = response.data
          this.success = result.success
          this.message = result.msg
          if (result.success) {
            this.submitExamFun()
          }else {
            alert(result.msg)
          }
        }, response => {
          alert('网络繁忙，请稍后重试！')
        })
      }
    },
    //提交考试
    submitExamFun() {
      var data = {
        'examRecordId': this.examRecordId
      }
      this.$http.post(API_ROOT.system + '/tjkExam/submitNormalExam', data).then(response => {
        var result = response.data
        this.success = result.success
        this.message = result.msg
        if (result.success) {
          this.$message({
            message: '已提交',
            type: 'success',
            center: true,
            duration: 1000
          })
          window.location.href = '/tjkStudy/examResult/' + this.examRecordId
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    //保存考试
    saveExam() {
      var arry = JSON.parse(JSON.stringify(this.list))

      for(var i=0;i<arry.length;i++) {
        if(typeof arry[i].tjkAnswerString != 'string') {
          for(var j=0;j<arry[i].tjkAnswerString.length;j++) {
            var reg= /^[A-Za-z]+$/
            if(arry[i].tjkAnswerString[j] == null) arry[i].tjkAnswerString[j] = ''
            if(reg.test(arry[i].tjkAnswerString[j])) arry[i].tjkAnswerString[j] = arry[i].tjkAnswerString[j].toUpperCase()
          }
          arry[i].tjkAnswerString = JSON.stringify(arry[i].tjkAnswerString)
        }
      }

      var data = {
        'tjkAnswerDetailList': arry
      }
      this.$http.post(API_ROOT.system + '/tjkExam/submitTjkAnswer', data).then(response => {
        var result = response.data
        this.success = result.success
        this.message = result.msg
        if (result.success) {
          this.$message({
            message: '已保存',
            type: 'success',
            center: true,
            duration: 1000
          })
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    //获取大题分类序号
    getNum(key) {
      var arry = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十']
      for(var i=0;i<arry.length;i++) {
        if(i == key) {
          return arry[i]
          break
        }
      }
    },
    //判断是否显示已答题样式
    getClass(string) {
      if(typeof string == 'boolean') {
        return true
      }else if(string instanceof Array) {
        for(var i=0;i<string.length;i++) {
          if(string[i] != '') {
            return true
            break
          }
        }
      }else if(string != '') {
        return true
      }else {
        return false
      }
    },
    clickImg(e) {
      this.showImg = true
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src
    },
    viewImg() {
      this.showImg = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// ./src/page/examTemp.vue